import { useEffect, useState } from 'react';
import { List, ListItem } from '../../../../components/List';
import { getPlayerHierarchy } from '../../api';
import { HIERARCHY_LEADERSHIP_TITLE } from '../../constants';
import { IHierarchySuperior } from '../../types';
import styles from './HierarchyLeadership.module.css';

interface IHierarchyLeadership {
  playerId?: string;
}

export function HierarchyLeadership({ playerId }: IHierarchyLeadership) {
  const [superiors, setSuperiors] = useState<IHierarchySuperior[]>([]);

  useEffect(() => {
    if (!playerId) return;

    let isActive = true;

    getPlayerHierarchy(playerId)
      .then((hierarchy) => {
        if (!isActive) return;
        setSuperiors(hierarchy?.enabled ? (hierarchy.superiors ?? []) : []);
      })
      .catch((error) => {
        if (!isActive) return;
        setSuperiors([]);
        console.log('error getPlayerHierarchy: ', error);
      });

    return () => {
      isActive = false;
    };
  }, [playerId]);

  if (superiors.length === 0) return null;

  return (
    <div className="mb-3">
      <List>
        <ListItem
          content={HIERARCHY_LEADERSHIP_TITLE}
          icon="groups"
          styleIcon="outlined"
          expansible
          contentExpansible={
            <List>
              {superiors.map((superior) => (
                <ListItem
                  key={superior.id}
                  icon="person"
                  styleIcon="outlined"
                  content={
                    <div className={styles.superior}>
                      {superior.role?.name && (
                        <p className="m-0 tiny-text">{superior.role.name}</p>
                      )}
                      <a
                        className={`${styles.managerLink} text-primary-color fw-semibold`}
                        href={`mailto:${superior.email}`}
                      >
                        {superior.name}
                      </a>
                    </div>
                  }
                />
              ))}
            </List>
          }
        />
      </List>
    </div>
  );
}
